import React from 'react';
import './MapWithDots.css';
import mapImage from './Images/map.jpg';

const dots = [
    { id: 1, name: 'USA', top: '37%', left: '24%', color: 'red' },
    { id: 2, name: 'USA', top: '34%', left: '27%', color: 'blue' },
    { id: 3, name: 'USA', top: '38%', left: '28%', color: 'green' },
    { id: 4, name: 'Brazil', top: '61%', left: '27%', color: 'green' },
    { id: 5, name: 'USA', top: '47%', left: '24%', color: 'red' },
    { id: 6, name: 'Spain', top: '43%', left: '44%', color: 'blue' },
    { id: 7, name: 'USA', top: '49%', left: '20%', color: 'green' },
    { id: 8, name: 'Camercon', top: '60%', left: '49%', color: 'yellow' },
    { id: 9, name: 'Ivory Coast', top: '58%', left: '44%', color: 'red' },
    { id: 10, name: 'UAE', top: '51%', left: '58%', color: 'blue' },
    { id: 11, name: 'Vietnam', top: '55%', left: '73%', color: 'red' },
    { id: 12, name: 'Kenya', top: '66%', left: '54%', color: 'green' },
    { id: 13, name: 'Kenya', top: '63%', left: '53%', color: 'yellow' },
    { id: 14, name: 'India', top: '55%', left: '66%', color: 'blue' },
    { id: 15, name: 'Brazil', top: '70%', left: '33%', color: 'yellow' },
    { id: 16, name: 'Netherland', top: '36%', left: '48%', color: 'red' },
    { id: 17, name: 'Netherland', top: '39%', left: '46%', color: 'green' },
    { id: 18, name: '', top: '50%', left: '53%', color: 'blue' },
    { id: 19, name: 'UAE', top: '53%', left: '59%', color: 'yellow' },
    { id: 20, name: 'Ankleshwar,India', top: '51%', left: '64%', color: 'green' },
];

const officeData = [
    {
        color: '#e74c3c',
        title: 'Head office',
        countries: [],
    },
    {
        color: '#27ae60',
        title: 'Global Offices',
        countries: [],
    },
    {
        color: '#f1c40f',
        title: 'Representative Offices',
        countries: [],
    },
    {
        color: '#007bcd',
        title: 'Stock Points',
        countries: [],
    },
];
  


const MapWithDots = () => {
    return (<>
        <div className="map-containerhp">
            <img src={mapImage} alt="World Map" className="map-image base-map" />
            {dots.map(dot => (
                <div key={dot.id} className="dot-wrapper" style={{ top: dot.top, left: dot.left }}>
                    <div className={`dot dot-${dot.color}`}></div>
                    <div className="tooltip">{dot.name}</div>
                    
                </div>
            ))}
        </div>


<div className="offices-wrapper">
{officeData.map((office, index) => (
  <div key={index} className="office-block">
    <div className="office-title">
      <span
        className="office-dot"
        style={{ backgroundColor: office.color }}
      />
      <span style={{ color: office.color }}>{office.title}</span>
    </div>
    <div className="office-locations">
      {office.countries.map((country, i) => (
        <span key={i}>
          {country}
          {i < office.countries.length - 1 ? ' | ' : ''}
        </span>
      ))}
    </div>
  </div>
))}
</div>
    </>
    );
};

export default MapWithDots;